import Vue from 'vue';

// Reuse the original action VNodes so v-auth, disabled, v-if and click handlers
// remain owned by the business page. Only their presentation is grouped.
export default Vue.extend({
    name: 'AdminRowActions',
    functional: true,
    props: { visible: { type: Number, default: 2 } },
    render(h, context) {
        const flatten = (nodes: any[]): any[] => nodes.reduce((result: any[], node: any) => {
            // Only unwrap inert grouping divs; conditional/authorized containers stay intact.
            if (node.tag === 'div' && (!node.data || !Object.keys(node.data).length)) {
                result.push(...flatten(node.children || []));
            } else if (node.tag || (node.text && node.text.trim())) {
                result.push(node);
            }
            return result;
        }, []);
        const actions = flatten(context.children || []);
        const visible = actions.slice(0, context.props.visible);
        const overflow = actions.slice(context.props.visible);
        if (overflow.length) {
            visible.push(h('el-dropdown', { props: { trigger: 'click', placement: 'bottom-end' } }, [
                h('el-button', { props: { type: 'text', size: 'small' }, attrs: { 'aria-label': '更多操作' } }, ['更多', h('i', { class: 'el-icon-arrow-down', attrs: { 'aria-hidden': 'true' } })]),
                h('el-dropdown-menu', { slot: 'dropdown', class: 'admin-row-action-menu' }, overflow.map((action, index) => h('el-dropdown-item', { key: index }, [action]))),
            ]));
        }
        return h('div', { class: 'admin-row-actions' }, visible);
    },
});
